import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6fbdbd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = { class: "title header-title mt-3" }
const _hoisted_3 = {
  key: 0,
  class: "input-group flex flex-column gap-2 mt-5 mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "menu-title" }, [
  /*#__PURE__*/_createTextVNode("配信頻度設定 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_5 = { class: "field col-12 px-0 ml-2 mt-3" }
const _hoisted_6 = { class: "flex flex-wrap gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_8 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-clock" })
], -1))
const _hoisted_11 = { class: "w-full flex justify-content-center mr-2 align-items-center" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "number_rate flex flex-column w-100" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "grid justify-content-end"
}
const _hoisted_17 = {
  key: 2,
  class: "card-overlay"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "d-flex justify-content-center" }
const _hoisted_21 = { class: "title header-title mt-3" }
const _hoisted_22 = { class: "input-group flex flex-column gap-2 mt-5" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("メッセージタイトル設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_24 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_25 = { class: "col p-0 ml-2" }
const _hoisted_26 = { class: "d-flex justify-content-end" }
const _hoisted_27 = { class: "input-group flex flex-column gap-2 mt-5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("配信日時設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_29 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_30 = {
  key: 1,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_31 = { class: "col-12 d-flex justify-content-start align-items-baseline" }
const _hoisted_32 = { class: "ml-2 -mr-2 hour-minute-container" }
const _hoisted_33 = {
  key: 2,
  class: "col-4 d-flex justify-content-start align-items-baseline input-description"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-3" }, "※初回配信日から何日後に配信するかを設定", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "input-group flex flex-column gap-2 mt-5" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("配信タイプ設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_38 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_39 = { class: "field col-12 px-0 ml-2 mt-3" }
const _hoisted_40 = { class: "flex flex-wrap gap-3" }
const _hoisted_41 = { class: "d-flex mr-5" }
const _hoisted_42 = ["for", "onClick"]
const _hoisted_43 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_44 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block mt-3",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("テキストメッセージ作成 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_46 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_47 = { class: "message-chat-input-container ml-2" }
const _hoisted_48 = { class: "flex justify-content-between align-items-center flex-wrap my-2 relative message-chat-input border-round-lg border-noround-bottom" }
const _hoisted_49 = { class: "flex justify-content-start" }
const _hoisted_50 = { class: "d-flex justify-content-center w-100" }
const _hoisted_51 = { class: "mb-2 p-dialog-title" }
const _hoisted_52 = { class: "message-chat-action" }
const _hoisted_53 = { class: "d-flex justify-content-end" }
const _hoisted_54 = {
  key: 1,
  class: "input-group flex flex-column gap-2 mt-5"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("URLリンク設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_56 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_57 = { class: "field col ml-2" }
const _hoisted_58 = {
  key: 2,
  class: "input-group flex flex-column gap-2 mt-5"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("画像設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_60 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_61 = {
  key: 3,
  class: "row d-flex justify-content-space-between"
}
const _hoisted_62 = { class: "col px-0 ml-2" }
const _hoisted_63 = { class: "row xl:flex lg:block justify-content-between" }
const _hoisted_64 = { class: "first-content pl-0" }
const _hoisted_65 = { class: "image-preview-container" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "px-0 second-content" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block mt-5",
  for: "menu-title"
}, "アクションタイプを選択", -1))
const _hoisted_69 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_70 = {
  key: 1,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_71 = { key: 2 }
const _hoisted_72 = { class: "d-flex justify-content-end" }
const _hoisted_73 = { key: 3 }
const _hoisted_74 = { key: 4 }
const _hoisted_75 = {
  key: 4,
  class: "grid justify-content-end"
}
const _hoisted_76 = {
  key: 0,
  class: "input-group flex flex-column gap-2 mt-5 mb-5"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "menu-title" }, [
  /*#__PURE__*/_createTextVNode("配信頻度設定 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_78 = { class: "field col-12 px-0 ml-2 mt-3" }
const _hoisted_79 = { class: "flex flex-wrap gap-3" }
const _hoisted_80 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_81 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-clock" })
], -1))
const _hoisted_84 = { class: "w-full flex justify-content-center mr-2 align-items-center" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "number_rate flex flex-column w-100" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = {
  key: 6,
  class: "grid mt-5 mb-5 justify-content-center"
}
const _hoisted_90 = {
  key: 7,
  class: "grid mt-5 justify-content-center"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_92 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 p-dialog-title" }, "下書き保存しました")
], -1))
const _hoisted_94 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_96 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-dialog-header align-items-center w-100 text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "custom-dialog-title header-title" }, "画像を選択")
], -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xl text-orange text-center" }, "↑ 画像をアクセス端末より選ぶ", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upload-image-text ml-4" }, "あらかじめ作成した画像を選択して挿入する。", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upload-image-text ml-4" }, "※ファイルサイズ：10MB以下", -1))
const _hoisted_101 = [
  _hoisted_98,
  _hoisted_99,
  _hoisted_100
]

import { ref, onBeforeMount, reactive, onBeforeUnmount, onMounted } from "vue";
import { onBeforeRouteLeave, useRouter } from "vue-router";

// Vue関連のインポート
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { get, set } from "@vueuse/core";

// PrimeVueコンポーネントのインポート
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import Calendar from "primevue/calendar";

// サードパーティライブラリのインポート
import { useStore } from "vuex";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import EmojiPicker from "vue3-emoji-picker";
import axios from "axios";
import { useCookies } from "@vueuse/integrations/useCookies";
import moment from "moment";

// サービス・ユーティリティのインポート
import { GROUP_NAMES_EMOJI, PLACEHOLDER_EMOJI } from "@/clinic/typings/constants/clinic";
import LiveMessageTemplate from "./LineMessageTemplate.vue";
import { ILineAccount } from "@/clinic/typings";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import rules from "../rule";
import { BookingHourOptions } from "@/clinic/typings/enums/booking";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageSetting',
  props: {
    isEdit: { type: Boolean },
    finalSetting: { type: Boolean },
    isDisplayHeader: { type: Boolean },
    isPickedTotalMessage: { type: Boolean },
    distributionGroupId: null,
    orderMessage: null,
    deliverySetting: null,
    messageSetting: null
  },
  emits: ["resourcesFn", "saveMessageSetting", "backFromFinalSetting"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** 編集モードかどうか */
  isEdit: boolean;
  /** 最終設定モードかどうか */
  finalSetting: boolean;
  /** ヘッダー表示フラグ */
  isDisplayHeader: boolean;
  /** 全メッセージ選択フラグ */
  isPickedTotalMessage: boolean;
  /** 配信グループID */
  distributionGroupId: string | number;
  /** メッセージ順序 */
  orderMessage: string;
  /** 配信設定情報 */
  deliverySetting: {
    delivery_frequency: number;
    message_type: number;
  };
  /** メッセージ設定情報 */
  messageSetting: any;
};

/**
 * ルーティン配信メッセージ設定コンポーネント
 *
 * このコンポーネントはルーティン配信グループのメッセージ設定を管理し、
 * 以下の機能を提供します：
 * - 配信頻度設定の表示
 * - メッセージタイトル設定
 * - 配信日時設定
 * - 配信タイプ設定（テキスト、URLリンク、画像）
 * - テキストメッセージ作成
 * - 画像アップロード機能
 * - 下書き保存機能
 * - プレビュー確認機能
 *
 * @component MessageSetting
 * @description ルーティン配信グループのメッセージ設定を管理するコンポーネント
 */

// Vue関連のインポート
const { get: getCookie } = useCookies();

const toast = useToast();
const router = useRouter();

/**
 * コンポーネントのプロパティ定義
 * @type {Object}
 */


/**
 * 分オプション配列
 * @type {Array}
 */
const BookingMinuteOptions = Array.from({ length: 60 }, (_, index) => ({
  name: `${index.toString().padStart(2, "0")}分`,
  value: `${index.toString().padStart(2, "0")}`,
}));

/**
 * 配信日時
 * @type {Ref<Date | string>}
 */
const deliveryDate = ref<Date | string>(new Date());

/**
 * ローディング状態
 * @type {Ref<boolean>}
 */
const isLoading = ref(false);

/**
 * 日オプション配列
 * @type {Ref<any[]>}
 */
const dayOptions = ref<any[]>([]);

/**
 * 次のメッセージまでの日数
 * @type {Ref<number>}
 */
const daysUntilNextMessage = ref<number>();

/**
 * 配信時間（時）
 * @type {Ref<string>}
 */
const deliveryHour = ref<string>("");

/**
 * 配信時間（分）
 * @type {Ref<string>}
 */
const deliveryMinute = ref<string>("");

/**
 * メッセージタイプ
 * @type {Ref<number>}
 */
const messageType = ref<number>(props.deliverySetting?.message_type);

/**
 * メッセージタイプコンテナ
 * @type {Ref<string[]>}
 */
const messageTypeContainer = ref<string[]>([]);

/**
 * 絵文字ピッカーラッパー
 * @type {Ref<any>}
 */
const emojiPickerWrapper = ref<any>();

/**
 * Vuexストア
 * @type {Store}
 */
const store = useStore();

/**
 * 画像アップロードポップアップ表示フラグ
 * @type {Ref<boolean>}
 */
const upLoadImagePopUp = ref(false);

/**
 * 下書き保存完了ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const saveDraftVisible = ref(false);

/**
 * 戻る警告ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const warningReturnVisible = ref(false);

/**
 * 既に下書き保存済みかどうか
 * @type {Ref<boolean>}
 */
const isAlreadySaveDraft = ref(false);

/**
 * 現在のメッセージ設定
 * @type {Ref<any[]>}
 */
const currentMessageSetting = ref<any[]>(props.messageSetting || []);

/**
 * 現在のメッセージ順序
 * @type {Ref<number>}
 */
const currentOrderMessage = ref<number>(Number(props.orderMessage) || 1);

/**
 * メッセージ設定エラー
 * @type {Ref<Record<string, any>>}
 */
const messageSettingErrors = ref<Record<string, any>>({});

/**
 * 画像アクション投稿バック
 * @type {Ref<string>}
 */
const imageActionPostBack = ref("");

/**
 * 画像アクションリンク
 * @type {Ref<string>}
 */
const imageActionLink = ref("");

/**
 * メッセージ画像URLプレビュー
 * @type {Ref<string>}
 */
const messageImageUrlPreview = ref("");

/**
 * メッセージリンクURL
 * @type {Ref<string>}
 */
const messageLinkUrl = ref("");

/**
 * メッセージタイトル
 * @type {Ref<string>}
 */
const messageTitle = ref("");

/**
 * メッセージ画像アクションタイプ
 * @type {Ref<string>}
 */
const messageImageActionType = ref("");

/**
 * URIタイプ
 * @type {Ref<string>}
 */
const uriType = ref("uri");

/**
 * メッセージテンプレートタイプ
 * @type {Ref<string>}
 */
const messageTemplateType = ref("");

/**
 * 配信グループメッセージID
 * @type {Ref<string>}
 */
const distributionGroupMessageId = ref("");

/**
 * 配信グループ画像ID
 * @type {Ref<string>}
 */
const distributionGroupImageId = ref("");

/**
 * クリニックID
 * @type {Ref<number>}
 */
const clinicId = ref(0);

/**
 * 画像ファイル
 * @type {Ref<any>}
 */
const imageFiles = ref<any>();

/**
 * ファイル配列
 * @type {Ref<any[]>}
 */
const files = ref<any[]>([]);

/**
 * メッセージテキスト内容
 * @type {Ref<string>}
 */
const messageTextContent = ref("");

/**
 * 絵文字表示フラグ
 * @type {Ref<boolean>}
 */
const emojiOnShow = ref(false);

/**
 * ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const dialogVisible = ref<boolean>(false);

/**
 * ページ離脱許可フラグ
 * @type {Ref<boolean>}
 */
const hasPermissionRedirect = ref(true);

/**
 * ページ離脱警告表示フラグ
 * @type {Ref<boolean>}
 */
const warningRedirectPage = ref(false);

/**
 * 次のルート
 * @type {Ref<string | null>}
 */
const nextRoute = ref<string | null>(null);

/**
 * メッセージコンテナ
 * @type {Ref<any[]>}
 */
const messageContainer = ref<any[]>([]);

/**
 * 配信頻度
 * @type {Ref<any[]>}
 */
const deliveryFrequency = ref<any[]>([]);

/**
 * 初期データ設定処理
 */
const initData = () => {
  set(messageContainer, createMessageContainer(props.deliverySetting.delivery_frequency));
  set(messageTypeContainer, createMessageTypeContainer());
  set(dayOptions, createDayOptions());
  set(deliveryFrequency, createDeliveryFrequency());
  getCurrentOrderMessage();
};

/**
 * 現在のメッセージ順序取得処理
 */
const getCurrentOrderMessage = () => {
  if (!get(currentMessageSetting)) return;
  if (props.isPickedTotalMessage) return;
  if (!props.isEdit) return;

  const messageChange = get(currentMessageSetting).find((message: any) => message.status != "delivered");
  if (messageChange && !props.finalSetting) {
    set(currentOrderMessage, messageChange.position);
  }
};

/**
 * 配信頻度作成処理
 * @returns {any[]} 配信頻度配列
 */
const createDeliveryFrequency = () => {
  let result: any[] = [];
  for (let i = 2; i <= 5; i++) {
    result.push({ frequency: i, name: `${i}回配信` });
  }

  return result;
};

/**
 * メッセージタイプ変更処理
 * @param {number} index - メッセージタイプインデックス
 */
const changeMessageType = (index: number) => {
  set(messageType, index);
  set(uriType, "uri");
};

/**
 * メッセージコンテナ作成処理
 * @param {number} frequency - 配信頻度
 * @returns {any[]} メッセージコンテナ配列
 */
const createMessageContainer = (frequency: number) => {
  let container: any[] = [];
  let firstDaySendAt: any;
  let messageDate: any;
  for (let i = 1; i <= frequency; i++) {
    const messageSetting = get(currentMessageSetting)?.find((message: any) => +message.position == i);
    if (i == 1) {
      firstDaySendAt = messageSetting?.send_at_date;
      messageDate = firstDaySendAt;
    }

    if (i != 1) {
      const currentMessageSendAt = messageSetting?.send_at_date;
      if (currentMessageSendAt) {
        messageDate = moment(currentMessageSendAt).diff(firstDaySendAt, "days");
        messageDate = `${messageDate}日後`;
      } else {
        messageDate = "0日後";
      }
    }

    const messageHour = messageSetting?.send_at_hour || "00";
    const messageMinute = messageSetting?.send_at_minute || "00";

    const messageFormat = {
      step: i,
      name: `${i}回目配信日時`,
      date: messageDate,
      defaultDate: i == 1 ? "0000年00月00日" : "00日後",
      time: "",
      title: messageSetting?.title,
      defaultTime: `${messageHour}:${messageMinute}`,
      defaultDescription: i == 1 ? "メッセージタイトル" : "ステップ配信",
      messageDescription: i == 1 ? "を設定してください" : `${i}回目メッセージ`,
    };

    container.push(messageFormat);
  }

  return container;
};

/**
 * メッセージタイプコンテナ作成処理
 * @returns {string[]} メッセージタイプ配列
 */
const createMessageTypeContainer = () => {
  return [
    "テキストメッセージ",
    "テキスト＋URLリンクメッセージ",
    "テキスト＋画像メッセージ",
    "テキスト＋URLリンク＋画像メッセージ",
  ];
};

/**
 * 日オプション作成処理
 * @returns {any[]} 日オプション配列
 */
const createDayOptions = () => {
  return Array.from({ length: 30 }, (_, i) => ({ name: `初回メッセージから${i + 1}日後`, value: i + 1 }));
};

/**
 * フォーム値リセット処理
 */
const resetFormValue = () => {
  set(distributionGroupMessageId, "");
  set(distributionGroupImageId, "");
  set(messageType, 0);
  set(messageTitle, "");
  set(deliveryDate, new Date());
  set(deliveryHour, "");
  set(deliveryMinute, "");
  set(messageTextContent, "");
  set(messageLinkUrl, "");
  set(uriType, "uri");
  set(messageImageUrlPreview, "");
  set(imageFiles, "");
  set(imageActionPostBack, "");
  set(imageActionLink, "");
  set(daysUntilNextMessage, 0);
};

/**
 * 入力日時計算処理
 */
const calculateInputDateTime = () => {
  if (get(currentOrderMessage) == 1) {
    let dateSetting = moment(get(deliveryDate));
    dateSetting.set({ hour: Number(get(deliveryHour)), minute: Number(get(deliveryMinute)) });
    set(deliveryDate, dateSetting.format("YYYY-MM-DD HH:mm"));
  } else {
    const firstMessageSetting = get(currentMessageSetting).find((message: any) => +message.position == 1);
    let firstMessageSendAt = moment(firstMessageSetting.send_at_date);
    firstMessageSendAt.add(get(daysUntilNextMessage), "days");
    firstMessageSendAt.set({ hour: Number(get(deliveryHour)), minute: Number(get(deliveryMinute)) });
    set(deliveryDate, firstMessageSendAt.format("YYYY-MM-DD HH:mm"));
  }
};

/**
 * バリデーション処理
 * @returns {Promise<boolean>} バリデーション結果
 */
const validate = async () => {
  const formObject = reactive({
    deliveryDate: deliveryDate.value,
    messageTitle: messageTitle.value,
    messageLinkUrl: messageLinkUrl.value,
    messageTextContent: messageTextContent.value,
    messageType: messageType,
    messageImage: imageFiles.value,
    messageImageActionType: messageImageActionType.value,
    imageActionPostBack: imageActionPostBack.value,
    imageActionLink: imageActionLink.value,
    uriType: uriType.value,
  });

  const initValidation = useAsyncValidator(formObject, rules);
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  messageSettingErrors.value = fErrorFields || {};
  return fPass;
};

const messageTypeOptions = ref([
  { name: "選択", value: "" },
  { name: "テキストタイプ", value: "postback" },
  { name: "リンクタイプ", value: "uri" },
  { name: "クーポンタイプ", value: "coupon" },
  { name: "予約", value: "booking_uri" },
]);

const uriTypeOptions = ref([
  { name: "通常のURL", value: "uri" },
  { name: "予約", value: "booking_uri" },
]);


const currentUser = ref<ILineAccount>({
  id: 0,
  line_user_id: "",
  clinic_id: 0,
  customer_id: 0,
  name: "",
  avatar_url: "",
  message: {
    id: 0,
    channel_id: "",
    line_user_id: "",
    content: "",
    message_type: "",
    sender_type: "",
    created_at: "",
  },
} as ILineAccount);

/**
 * 最終ステップから戻る処理
 * @param {number} step - ステップ番号
 * @param {number} currentOrderMessage - 現在のメッセージ順序
 */
const backFromFinalStep = (step: number, currentOrderMessage: number) => {
  emits("backFromFinalSetting", step, currentOrderMessage);
};

/**
 * 十分なメッセージ設定があるかチェック
 * @returns {boolean} 十分な設定があるかどうか
 */
const enoughMessageSetting = () => {
  const numMessage = props.deliverySetting?.delivery_frequency;
  return get(currentMessageSetting).length == numMessage;
};

/**
 * 入力日時の妥当性チェック
 * @returns {boolean} 妥当性チェック結果
 */
const validateInputDateTime = () => {
  if (get(currentOrderMessage) < 2) return true;

  const previousMessage = get(currentMessageSetting).find(
    (message: any) => +message.position == get(currentOrderMessage) - 1
  );
  const nextMessage = get(currentMessageSetting).find(
    (message: any) => +message.position == get(currentOrderMessage) + 1
  );

  let previousMessageSendAt = moment(previousMessage.send_at_date);
  previousMessageSendAt.set({ hour: previousMessage.send_at_hour, minute: previousMessage.send_at_minute });

  const currentMessageSendAt = moment(get(deliveryDate));
  let validParams = false;
  validParams = currentMessageSendAt > previousMessageSendAt;

  if (nextMessage) {
    let nextMessageSendAt = moment(nextMessage.send_at_date);
    nextMessageSendAt.set({ hour: nextMessage.send_at_hour, minute: nextMessage.send_at_minute });
    validParams = validParams && currentMessageSendAt < nextMessageSendAt;
  }

  return validParams;
};

/**
 * 設定更新処理
 * @param {boolean} isSaveDraft - 下書き保存フラグ
 * @returns {Promise<any>} 更新結果
 */
const updateSetting = async (isSaveDraft = false) => {
  set(isLoading, true);
  messageSettingErrors.value = {};
  set(saveDraftVisible, false);
  calculateInputDateTime();
  const inputDateTime = new Date(get(deliveryDate));
  const currentDateTime = new Date();
  const isValidDateTime = validateInputDateTime();
  if (!isValidDateTime || inputDateTime <= currentDateTime) {
    messageSettingErrors.value.deliveryDate = [{ message: "配信メッセージの日時が無効です。" }];
    set(warningRedirectPage, false);
    set(warningReturnVisible, false);
    set(isLoading, false);
    return new Promise((_resolve, reject) => {
      reject("配信メッセージの日時が無効です。");
    });
  }

  const isValidParams = await validate();
  if (!isValidParams) {
    set(warningRedirectPage, false);
    set(warningReturnVisible, false);
    set(isLoading, false);
    return new Promise((_resolve, reject) => {
      reject("入力内容に不備があります。各項目を確認してください");
    });
  }

  return new Promise((resolve, reject) => {
    const formData = new FormData();
    const messages = buildBodyCreate();
    messages["messages"].forEach((obj, index) => {
      for (let key in obj) {
        formData.append(`message_setting[${index}][${key}]`, obj[key]);
      }
    });

    formData.append("message_id", messages["id"]);
    formData.append("title", get(messageTitle));
    formData.append("message_type", String(get(messageType)));
    formData.append("send_at", String(get(deliveryDate)));
    formData.append("position", String(get(currentOrderMessage)));
    formData.append("delivery_frequency", String(props.deliverySetting.delivery_frequency));
    if (isSaveDraft) {
      formData.append("status", "draft");
    }

    const token = getCookie("access_token");
    axios
      .patch(
        `${ApiRouterConstants.API_DISTRIBUTION_GROUPS}/${props.distributionGroupId}/message_settings?clinic_id=${clinicId.value}`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(response => {
        set(currentMessageSetting, response.data["group_messages"]);

        if (isSaveDraft) {
          emits("saveMessageSetting", 4, get(currentMessageSetting));
          if (get(warningRedirectPage)) {
            set(warningRedirectPage, false);
            set(hasPermissionRedirect, true);
            if (nextRoute.value) {
              router.push(nextRoute.value);
            }
          } else {
            if (get(warningReturnVisible)) {
              back();
            } else {
              set(warningReturnVisible, false);
              set(saveDraftVisible, true);
            }
          }

          set(isAlreadySaveDraft, true);
        } else {
          emits("saveMessageSetting", null, get(currentMessageSetting));
          assignMessageSettingAttribute(get(currentMessageSetting));
          set(messageContainer, createMessageContainer(props.deliverySetting.delivery_frequency));
        }

        set(warningReturnVisible, false);
        set(isLoading, false);
        resolve(response);
      })
      .catch(error => {
        console.log("errors", error);
        set(isLoading, false);
        reject("何かが間違っています。後でもう一度試してください");
      });
  });
};

/**
 * メッセージ設定変更処理
 * @param {number} orderMessage - メッセージ順序
 */
const changeMessageSetting = async (orderMessage: number) => {
  if (+orderMessage == +get(currentOrderMessage)) return;

  const messageChange = get(currentMessageSetting).find((message: any) => +message.position == +orderMessage);
  if (messageChange && messageChange.status == "delivered") {
    notityErrorMsg(toast, "送信済みのメッセージは編集できません。");
    return;
  }

  set(isLoading, true);

  const [errUpdate] = await handleError(updateSetting());
  if (errUpdate) {
    notityErrorMsg(toast, errUpdate);
  } else {
    resetFormValue();
    set(isLoading, false);
    set(currentOrderMessage, orderMessage);
    assignMessageSettingAttribute(get(currentMessageSetting));
  }
};

/**
 * TOPページに戻る処理
 */
const returnTop = () => {
  set(hasPermissionRedirect, true);
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_ROUTINE_GROUP_ROUTER_NAME);
};

/**
 * 現在のページに戻る処理
 */
const returnCurrentPage = () => {
  warningReturnVisible.value = false;
  saveDraftVisible.value = false;
};

/**
 * 下書き保存処理
 */
const saveDraft = async () => {
  set(isLoading, true);
  const [errUpdate] = await handleError(updateSetting(true));
  if (errUpdate) {
    notityErrorMsg(toast, errUpdate);
  }

  set(isLoading, false);
};

onBeforeRouteLeave((to, _from, next) => {
  if (props.finalSetting) {
    next();
    return;
  }

  if (get(hasPermissionRedirect)) {
    next();
  } else {
    set(warningRedirectPage, true);
    set(nextRoute, to.fullPath);
    next(false);
  }
});

/**
 * 戻るボタン処理
 */
const handleBackButton = () => {
  if (isAlreadySaveDraft.value) {
    warningReturnVisible.value = false;
    emits("resourcesFn", 3);
  } else {
    warningReturnVisible.value = true;
  }
};

/**
 * 変更破棄処理
 */
const disCardChanged = () => {
  emits("saveMessageSetting", 3, props.messageSetting);
};

/**
 * リダイレクト時の破棄処理
 */
const destroyWhenRedirect = async () => {
  try {
    if (!props.isEdit) {
      await DistributionGroupService.destroy(props.distributionGroupId);
    }
    set(hasPermissionRedirect, true);
    if (get(nextRoute)) {
      if (nextRoute.value) {
        router.push(nextRoute.value);
      }
    }
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * ページ離脱前の処理
 * @param {BeforeUnloadEvent} event - ページ離脱イベント
 */
const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = "";
  window.addEventListener("unload", async function () {
    if (!props.isEdit) {
      const url = `${ApiRouterConstants.API_DISTRIBUTION_GROUPS}/${props.distributionGroupId}`;
      await fetch(url, { method: "DELETE", keepalive: true });
    }
  });
};

/**
 * 保存処理
 */
const save = async () => {
  if (isAlreadySaveDraft.value) {
    if (enoughMessageSetting()) {
      emits("saveMessageSetting", 5, currentMessageSetting.value);
    } else {
      emits("saveMessageSetting", null, currentMessageSetting.value);
    }

    return;
  }

  const [errUpdate] = await handleError(updateSetting());
  if (errUpdate) {
    notityErrorMsg(toast, errUpdate);
  } else {
    if (enoughMessageSetting()) {
      emits("saveMessageSetting", 5, get(currentMessageSetting));
    } else {
      notityErrorMsg(toast, "配信設定が不足しています。すべての配信設定を設定してください。");
    }
  }
};

/**
 * エラーハンドリング処理
 * @param {Promise<any>} promise - 処理対象のPromise
 * @returns {Promise<[any, any]>} エラーとデータの配列
 */
const handleError = (promise: Promise<any>) => {
  return promise.then((data: any) => [undefined, data]).catch((error: any) => [error, undefined]);
};

/**
 * ボディ作成処理
 * @returns {Object} 作成されたボディオブジェクト
 */
const buildBodyCreate = () => {
  const messages = Object.values(messageSettings());
  const messageParams = messages.map((message: any) => {
    return message();
  });

  const filterMessage = messageParams.filter((message: any) => message != null);
  return { id: get(distributionGroupMessageId), messages: filterMessage.flat(2) };
};

/**
 * 日数差計算処理
 * @param {any} date1 - 日付1
 * @param {any} date2 - 日付2
 * @returns {number} 日数差
 */
const calcDiffDays = (date1: any, date2: any) => {
  const diffInMillis = Math.abs(date2.diff(date1));
  const duration = moment.duration(diffInMillis);
  return Math.floor(duration.asDays());
};

/**
 * メッセージ設定属性割り当て処理
 * @param {any} messageSettings - メッセージ設定
 */
const assignMessageSettingAttribute = (messageSettings: any) => {
  if (!messageSettings) return;

  const filterMessageSetting = messageSettings.find((message: any) => message["position"] == get(currentOrderMessage));
  if (!filterMessageSetting) {
    return;
  }

  set(distributionGroupMessageId, filterMessageSetting.id);
  set(messageType, filterMessageSetting.message_type);
  set(messageTitle, filterMessageSetting.title);
  set(deliveryDate, new Date(filterMessageSetting.send_at_date));
  set(deliveryHour, filterMessageSetting.send_at_hour);
  set(deliveryMinute, filterMessageSetting.send_at_minute);

  const firstMessageSetting = get(currentMessageSetting).find((message: any) => +message.position == 1);
  const date1 = moment(firstMessageSetting.send_at_date);
  const date2 = moment(filterMessageSetting.send_at_date);
  const diffDays = calcDiffDays(date1, date2);
  set(daysUntilNextMessage, diffDays);

  filterMessageSetting["messages"].forEach((message: any) => {
    assignTextMessageAttribute(message);
    assignUriMessageAttribute(message);
    assignImageMessageAttribute(message);
  });
};

/**
 * テキストメッセージ属性割り当て処理
 * @param {any} message - メッセージオブジェクト
 */
const assignTextMessageAttribute = (message: any) => {
  if (message["content_type"] != "text") return;

  set(messageTextContent, message.content_data);
};

/**
 * URIメッセージ属性割り当て処理
 * @param {any} message - メッセージオブジェクト
 */
const assignUriMessageAttribute = (message: any) => {
  if (message["content_type"] != "uri") return;

  uriType.value = get(messageType) == 4 ? "uri" : message?.content_label;
  set(messageLinkUrl, message.content_data);
  set(uriType, message.content_label);
};

/**
 * 画像メッセージ属性割り当て処理
 * @param {any} message - メッセージオブジェクト
 */
const assignImageMessageAttribute = (message: any) => {
  if (message["content_type"] != "image") return;

  set(messageImageUrlPreview, message.content_data);
  set(imageFiles, message.content_data);
  set(distributionGroupImageId, message.distribution_group_image_id);
  set(messageImageActionType, message.message_action_type);
  if (message.message_action_type === "postback") {
    set(imageActionPostBack, message.message_action_data);
  } else if (message.message_action_type === "uri") {
    set(imageActionLink, message.message_action_data);
  } else if (message.message_action_type === "coupon") {
    set(imageActionLink, message.message_action_data);
  }
};

/**
 * メッセージ設定関数
 * @returns {Object} メッセージ設定オブジェクト
 */
function messageSettings() {
  return {
    firstMessage: buildFirstMessage,
    secondMessage: buildSecondMessage,
  };
}

/**
 * 最初のメッセージ構築処理
 * @returns {any} 構築されたメッセージ
 */
function buildFirstMessage() {
  const messageContent = Object.values(firstMessageContent());
  if (messageContent.length == 0) return;

  return messageContent;
}

/**
 * 最初のメッセージ内容作成処理
 * @returns {any} メッセージ内容オブジェクト
 */
const firstMessageContent = () => {
  let messageContent: any = {
    text: { content_type: "text", content_data: messageTextContent.value },
  };

  if ([2, 4].includes(get(messageType))) {
    messageContent["link"] = { content_type: "uri", content_data: messageLinkUrl.value, content_label: uriType.value };
  }

  return messageContent;
};

/**
 * 2番目のメッセージ構築処理
 * @returns {any} 構築されたメッセージ
 */
function buildSecondMessage() {
  const messageContent = Object.values(secondMessageContent());
  if (messageContent.length == 0) return;

  return Object.values(secondMessageContent());
}

/**
 * 2番目のメッセージ内容作成処理
 * @returns {any} メッセージ内容オブジェクト
 */
const secondMessageContent = () => {
  if ([1, 2].includes(get(messageType))) return [];

  const response = {
    image: {
      distribution_group_image_id: distributionGroupImageId.value,
      content_type: "image",
      content_data: imageFiles.value,
      message_action_type: messageImageActionType.value,
      message_action_data: messageImageActionData(messageImageActionType.value),
    },
  };
  return response;
};

/**
 * メッセージ画像アクションデータ取得処理
 * @param {any} action_type - アクションタイプ
 * @returns {any} アクションデータ
 */
const messageImageActionData = (action_type: any) => {
  return {
    postback: imageActionPostBack.value,
    uri: imageActionLink.value,
    coupon: imageActionLink.value,
  }[String(action_type)];
};

/**
 * 絵文字選択処理
 * @param {any} emoji - 選択された絵文字
 */
const onSelectEmoji = (emoji: any) => {
  messageTextContent.value += emoji.i;
};

/**
 * 絵文字表示切り替え処理
 */
const showEmoji = () => {
  emojiOnShow.value = !emojiOnShow.value;
};

/**
 * テンプレート追加処理
 */
const addTemplate = () => {
  set(messageTemplateType, "add");
  dialogVisible.value = true;
};

/**
 * テンプレートポップアップ閉じる処理
 */
const onCloseTemplatePopup = () => {
  set(messageTemplateType, "");
  dialogVisible.value = false;
};

/**
 * テンプレート挿入処理
 * @param {any} template - 挿入するテンプレート
 */
const onInsertTemplate = (template: any) => {
  dialogVisible.value = false;
  const content = template.content_string
    .replaceAll("{{CustomerName}}", get(currentUser).name)
    .replaceAll("{{ClinicName}}", store.getters["authClient/selectedClinic"].name);
  set(messageTextContent, content);
};

/**
 * メッセージプレビュー処理
 */
const previewMessage = () => {
  set(messageTemplateType, "preview");
  dialogVisible.value = true;
};

/**
 * 戻る処理
 */
const back = () => {
  emits("resourcesFn", 3);
  set(warningReturnVisible, false);
};

/**
 * ファイル入力トリガー処理
 */
const triggerFileInput = () => {
  upLoadImagePopUp.value = false;
  document.getElementById("uploadImage")?.click();
};

/**
 * ファイル入力処理
 * @param {Event} event - ファイル入力イベント
 */
const handleFileInput = (event: Event) => {
  // Handle the file input
  const file = (event.target as HTMLInputElement).files?.[0];
  const reader = new FileReader();
  reader.onload = (e: ProgressEvent<FileReader>) => {
    if (e.target?.result) {
      set(messageImageUrlPreview, e.target.result);
      set(imageFiles, file);
    }
  };
  if (file) {
    reader.readAsDataURL(file);
  }
};

/**
 * クリニック情報読み込み処理
 */
const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

/**
 * コンポーネントアンマウント前の処理
 */
onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});

/**
 * コンポーネントマウント時の処理
 */
onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  document.getElementById("step-setting")?.scrollIntoView();
});

/**
 * ドキュメントクリック処理
 * @param {Event} event - クリックイベント
 */
const handleDocumentClick = (event: Event) => {
  if (emojiOnShow.value && emojiPickerWrapper.value && !emojiPickerWrapper.value.contains(event.target)) {
    emojiOnShow.value = false;
  }
};

/**
 * コンポーネントマウント前の処理
 */
onBeforeMount(async () => {
  document.addEventListener("click", handleDocumentClick);
  set(isLoading, true);
  await loadClinicInfo();
  initData();
  assignMessageSettingAttribute(props.messageSetting);
  set(isLoading, false);
});

return (_ctx: any,_cache: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-content-wrapper", { 'pointer-events-none': props.finalSetting }])
    }, [
      (props.isDisplayHeader)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 0,
            class: "mb-5 border-round-lg mt-5"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("label", _hoisted_2, _toDisplayString(props.finalSetting ? "ルーティン配信設定" : "メッセージ設定"), 1)
              ])
            ]),
            content: _withCtx(() => [
              (props.finalSetting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryFrequency.value, (message, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "col-2 flex align-items-center radio-wrapper__custom"
                          }, [
                            _createVNode(_component_RadioButton, { name: "display_price" }),
                            _createElementVNode("label", {
                              for: "display-price",
                              class: _normalizeClass(["flex algin-items-center", { 'text-orange': message.frequency == props.deliverySetting.delivery_frequency }])
                            }, [
                              (message.frequency == props.deliverySetting.delivery_frequency)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                                : (_openBlock(), _createElementBlock("span", _hoisted_8)),
                              _createTextVNode(" " + _toDisplayString(message.name), 1)
                            ], 2)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "action_rate message-delivery-time-block",
                style: _normalizeStyle({ 'grid-template-columns': 'repeat(' + +__props.deliverySetting.delivery_frequency + ', 1fr)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageContainer.value, (message, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (__props.deliverySetting.delivery_frequency >= message.step)
                      ? (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (changeMessageSetting(message.step)),
                          key: index,
                          class: _normalizeClass([
                'block_rate message-container-title border-grey background-grey cursor-pointer',
                {
                  'border-orange background-orange': props.isPickedTotalMessage || currentOrderMessage.value == message.step,
                },
              ])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'number_rate flex w-100',
                  { 'text-white': props.isPickedTotalMessage || currentOrderMessage.value == message.step },
                ])
                          }, [
                            _hoisted_10,
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("span", {
                                class: _normalizeClass([{ 'text-white': props.isPickedTotalMessage || currentOrderMessage.value == message.step }])
                              }, _toDisplayString(message.name), 3)
                            ])
                          ], 2)
                        ], 10, _hoisted_9))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ], 4),
              _createElementVNode("div", {
                class: "action_rate message-delivery-time-block",
                style: _normalizeStyle({ 'grid-template-columns': 'repeat(' + __props.deliverySetting.delivery_frequency + ', 1fr)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageContainer.value, (message, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (__props.deliverySetting.delivery_frequency >= message.step)
                      ? (_openBlock(), _createElementBlock("div", {
                          class: "block_rate border-none cursor-pointer",
                          key: index,
                          onClick: ($event: any) => (changeMessageSetting(message.step))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'number_rate flex flex-column w-100',
                  { 'step-time-picked': props.isPickedTotalMessage || currentOrderMessage.value == message.step },
                ])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(message.date || message.defaultDate), 1),
                            _createElementVNode("span", null, _toDisplayString(message.time || message.defaultTime), 1)
                          ], 2)
                        ], 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ], 4),
              _createElementVNode("div", {
                class: "action_rate",
                style: _normalizeStyle({ 'grid-template-columns': 'repeat(' + __props.deliverySetting.delivery_frequency + ', 1fr)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageContainer.value, (message, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (__props.deliverySetting.delivery_frequency >= message.step)
                      ? (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (changeMessageSetting(message.step)),
                          key: index,
                          class: _normalizeClass([
                'block_rate border-grey cursor-pointer',
                { 'border-orange step-time-picked': props.isPickedTotalMessage || currentOrderMessage.value == message.step },
              ])
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            (!message.title)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(message.defaultDescription), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(message.title || message.messageDescription), 1)
                          ])
                        ], 10, _hoisted_13))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ], 4)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (props.finalSetting && props.isDisplayHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_Button, {
              class: "col-2 create-btn ml-5 cursor-pointer pre-pointer-event",
              label: "編集画面に戻る",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (backFromFinalStep(3, currentOrderMessage.value)))
            })
          ]))
        : _createCommentVNode("", true),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
        : _createCommentVNode("", true),
      (!isLoading.value)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 3,
            class: "mb-5 border-round-lg mt-5"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(props.finalSetting && currentOrderMessage.value == 1
              ? "初回配信メッセージ設定"
              : `${currentOrderMessage.value}回目配信メッセージ設定`), 1)
              ])
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                (messageSettingErrors.value?.messageTitle)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(messageSettingErrors.value?.messageTitle[0]?.message), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_InputText, {
                    modelValue: messageTitle.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((messageTitle).value = $event)),
                    "aria-describedby": "time-unit-help",
                    size: "large",
                    name: "can_booking_before_call",
                    class: "w-full mt-2 border-round-lg"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, _toDisplayString(messageTitle.value.length) + " / 20", 1),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                (messageSettingErrors.value?.deliveryDate)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(messageSettingErrors.value?.deliveryDate[0]?.message), 1))
                  : _createCommentVNode("", true),
                (messageSettingErrors.value?.deliveryHour)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_30, _toDisplayString(messageSettingErrors.value?.deliveryHour[0]?.message), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_Button, {
                    label: "配信日時",
                    class: "mr-2 target-button delivery-date-btn"
                  }),
                  (currentOrderMessage.value != 1)
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 0,
                        modelValue: daysUntilNextMessage.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((daysUntilNextMessage).value = $event)),
                        "aria-describedby": "time-unit-help",
                        size: "large",
                        type: "number",
                        min: "1",
                        placeholder: "初回配信日から何日後に配信しますか？",
                        name: "can_booking_before_call",
                        class: "col-4 mt-2 border-round-lg"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  (currentOrderMessage.value == 1)
                    ? (_openBlock(), _createBlock(_unref(Calendar), {
                        key: 1,
                        id: "deliveryDate",
                        modelValue: deliveryDate.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deliveryDate).value = $event)),
                        "aria-describedby": "deliveryDate-help delivery-date-btn delivery-dropdown",
                        type: "date",
                        size: "large",
                        showIcon: "",
                        placeholder: "yyyy/mm/dd",
                        dateFormat: "yy/mm/dd"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Dropdown, {
                      modelValue: deliveryHour.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((deliveryHour).value = $event)),
                      options: _unref(BookingHourOptions),
                      optionLabel: "name",
                      optionValue: "value",
                      class: "mr-2 max-w-6rem font-normal delivery-date-btn delivery-dropdown",
                      inputProps: { class: 'font-light text-black20 text-sm' }
                    }, null, 8, ["modelValue", "options"]),
                    _createTextVNode(" : "),
                    _createVNode(_component_Dropdown, {
                      modelValue: deliveryMinute.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((deliveryMinute).value = $event)),
                      options: _unref(BookingMinuteOptions),
                      optionLabel: "name",
                      optionValue: "value",
                      class: "mr-2 ml-2 max-w-6rem font-normal delivery-date-btn delivery-dropdown",
                      inputProps: { class: 'font-light text-black20 text-sm' }
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                (currentOrderMessage.value != 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                (messageSettingErrors.value?.messageType)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_38, _toDisplayString(messageSettingErrors.value?.messageType[0]?.message), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
                      return _createElementVNode("div", {
                        class: "align-items-center radio-wrapper__custom col-4",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_RadioButton, {
                            modelValue: messageType.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((messageType).value = $event)),
                            inputId: `message-option-${index}`,
                            name: `message_option_${index}`,
                            value: index,
                            onClick: ($event: any) => (changeMessageType(index))
                          }, null, 8, ["modelValue", "inputId", "name", "value", "onClick"]),
                          _createElementVNode("label", {
                            for: `message-option-${index}`,
                            class: _normalizeClass(["flex algin-items-center", { 'text-orange': messageType.value == index }]),
                            onClick: ($event: any) => (changeMessageType(index))
                          }, [
                            (messageType.value == index)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                              : (_openBlock(), _createElementBlock("span", _hoisted_44)),
                            _createTextVNode(" " + _toDisplayString(messageTypeContainer.value[index - 1]), 1)
                          ], 10, _hoisted_42)
                        ])
                      ])
                    }), 64))
                  ])
                ])
              ]),
              _hoisted_45,
              (messageSettingErrors.value?.messageTextContent)
                ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString(messageSettingErrors.value?.messageTextContent[0]?.message), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", {
                      class: "w-full flex justify-content-end",
                      ref_key: "emojiPickerWrapper",
                      ref: emojiPickerWrapper
                    }, [
                      _createVNode(_unref(EmojiPicker), {
                        onSelect: onSelectEmoji,
                        class: _normalizeClass(["absolute emoji-picker", { hidden: !emojiOnShow.value }]),
                        "group-names": _unref(GROUP_NAMES_EMOJI),
                        native: true,
                        "static-texts": _unref(PLACEHOLDER_EMOJI)
                      }, null, 8, ["class", "group-names", "static-texts"]),
                      _createElementVNode("span", {
                        class: "icon-lms_face icon",
                        onClick: showEmoji
                      })
                    ], 512),
                    _createElementVNode("span", {
                      class: "pi pi-comment btn-la-chat-plus cursor-pointer",
                      onClick: addTemplate
                    }),
                    _createVNode(_component_Dialog, {
                      visible: dialogVisible.value,
                      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisible).value = $event)),
                      modal: "",
                      class: "preview-image-dialog",
                      style: _normalizeStyle(messageTemplateType.value === 'add' ? { width: '75vw' } : { width: '50vw' })
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("p", _hoisted_51, _toDisplayString(messageTemplateType.value == "add" ? "コンテンツを選択" : "プレビュー確認"), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(LiveMessageTemplate, {
                          onOnClose: onCloseTemplatePopup,
                          onOnInsert: onInsertTemplate,
                          previewType: messageTemplateType.value,
                          previewMessageContent: messageTextContent.value,
                          previewUrlContent: [2, 4].includes(messageType.value) ? messageLinkUrl.value : undefined,
                          previewImageContent: [3, 4].includes(messageType.value) ? messageImageUrlPreview.value : undefined
                        }, null, 8, ["previewType", "previewMessageContent", "previewUrlContent", "previewImageContent"])
                      ]),
                      _: 1
                    }, 8, ["visible", "style"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _withDirectives(_createVNode(_component_Textarea, {
                    class: "w-full border-round-lg border-noround-top",
                    rows: "5",
                    placeholder: "メッセージを入力。メッセージを入力",
                    modelValue: messageTextContent.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((messageTextContent).value = $event))
                  }, null, 8, ["modelValue"]), [
                    [_vShow, files.value.length <= 0]
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, _toDisplayString(messageTextContent.value.length) + " / 500", 1)
              ]),
              ([2, 4].includes(messageType.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _hoisted_55,
                    (messageSettingErrors.value?.messageLinkUrl)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_56, _toDisplayString(messageSettingErrors.value?.messageLinkUrl[0]?.message), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_57, [
                      (messageType.value == 2)
                        ? (_openBlock(), _createBlock(_component_Dropdown, {
                            key: 0,
                            modelValue: uriType.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((uriType).value = $event)),
                            optionLabel: "name",
                            optionValue: "value",
                            class: "w-full input-custom border-round-lg",
                            options: uriTypeOptions.value
                          }, null, 8, ["modelValue", "options"]))
                        : _createCommentVNode("", true),
                      (uriType.value == 'uri')
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 1,
                            modelValue: messageLinkUrl.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((messageLinkUrl).value = $event)),
                            "aria-describedby": "time-unit-help",
                            size: "large",
                            name: "can_booking_before_call",
                            class: "w-full mt-2 border-round-lg"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ([3, 4].includes(messageType.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _hoisted_59,
                    (messageSettingErrors.value?.messageImage)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_60, _toDisplayString(messageSettingErrors.value?.messageImage[0]?.message), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              ([3, 4].includes(messageType.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            (messageImageUrlPreview.value)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: messageImageUrlPreview.value,
                                  type: "file",
                                  class: "image-preview border-round-lg",
                                  alt: "Image Preview"
                                }, null, 8, _hoisted_66))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createVNode(_component_Button, {
                            label: "画像を選択",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (upLoadImagePopUp.value = true)),
                            class: "btn-outline btn-outline-orange"
                          }),
                          _createElementVNode("input", {
                            type: "file",
                            id: "uploadImage",
                            accept: ".jpg,.jpeg,.png",
                            ref: "fileInput",
                            onChange: handleFileInput,
                            style: {"display":"none"}
                          }, null, 544),
                          _hoisted_68,
                          (messageSettingErrors.value?.imageActionPostBack)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_69, _toDisplayString(messageSettingErrors.value?.imageActionPostBack[0]?.message), 1))
                            : _createCommentVNode("", true),
                          (messageSettingErrors.value?.imageActionLink)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_70, _toDisplayString(messageSettingErrors.value?.imageActionLink[0]?.message), 1))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Dropdown, {
                            modelValue: messageImageActionType.value,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((messageImageActionType).value = $event)),
                            optionLabel: "name",
                            optionValue: "value",
                            class: "w-full input-custom border-round-lg",
                            options: messageTypeOptions.value
                          }, null, 8, ["modelValue", "options"]),
                          (messageImageActionType.value == 'postback')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                _createVNode(_component_Textarea, {
                                  modelValue: imageActionPostBack.value,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((imageActionPostBack).value = $event)),
                                  "aria-describedby": "description-help",
                                  type: "text",
                                  size: "large",
                                  name: "note",
                                  rows: "10",
                                  cols: "30",
                                  class: "textarea-note w-100 mt-5 border-round-lg",
                                  placeholder: "顧客の情報を追加できます。メモの情報は相手には公開されません。"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_72, _toDisplayString(imageActionPostBack.value.length) + " / 100", 1)
                              ]))
                            : _createCommentVNode("", true),
                          (messageImageActionType.value == 'uri')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _createVNode(_component_InputText, {
                                  modelValue: imageActionLink.value,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((imageActionLink).value = $event)),
                                  "aria-describedby": "time-unit-help",
                                  size: "large",
                                  name: "can_booking_before_call",
                                  class: "w-full mt-5 border-round-lg",
                                  placeholder: "URLを入力"
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          (messageImageActionType.value == 'coupon')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                _createVNode(_component_InputText, {
                                  modelValue: imageActionLink.value,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((imageActionLink).value = $event)),
                                  "aria-describedby": "time-unit-help",
                                  size: "large",
                                  name: "can_booking_before_call",
                                  class: "w-full mt-5 border-round-lg",
                                  placeholder: "URLを入力"
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (props.finalSetting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
            _createVNode(_component_Button, {
              class: "col-2 create-btn ml-5 cursor-pointer pre-pointer-event",
              label: "編集画面に戻る",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (backFromFinalStep(4, currentOrderMessage.value)))
            })
          ]))
        : _createCommentVNode("", true),
      (__props.finalSetting == false && !isLoading.value)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 5,
            class: "mb-5 border-round-lg"
          }, {
            content: _withCtx(() => [
              (props.finalSetting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    _hoisted_77,
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryFrequency.value, (message, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "col-2 flex align-items-center radio-wrapper__custom"
                          }, [
                            _createVNode(_component_RadioButton, { name: "display_price" }),
                            _createElementVNode("label", {
                              for: "display-price",
                              class: _normalizeClass(["flex algin-items-center", { 'text-orange': message.frequency == props.deliverySetting.delivery_frequency }])
                            }, [
                              (message.frequency == props.deliverySetting.delivery_frequency)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80))
                                : (_openBlock(), _createElementBlock("span", _hoisted_81)),
                              _createTextVNode(" " + _toDisplayString(message.name), 1)
                            ], 2)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "action_rate message-delivery-time-block",
                style: _normalizeStyle({ 'grid-template-columns': 'repeat(' + +__props.deliverySetting.delivery_frequency + ', 1fr)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageContainer.value, (message, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (__props.deliverySetting.delivery_frequency >= message.step)
                      ? (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (changeMessageSetting(message.step)),
                          key: index,
                          class: _normalizeClass([
                'block_rate message-container-title border-grey background-grey cursor-pointer',
                {
                  'border-orange background-orange': props.isPickedTotalMessage || currentOrderMessage.value == message.step,
                },
              ])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'number_rate flex w-100',
                  { 'text-white': props.isPickedTotalMessage || currentOrderMessage.value == message.step },
                ])
                          }, [
                            _hoisted_83,
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("span", {
                                class: _normalizeClass([{ 'text-white': props.isPickedTotalMessage || currentOrderMessage.value == message.step }])
                              }, _toDisplayString(message.name), 3)
                            ])
                          ], 2)
                        ], 10, _hoisted_82))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ], 4),
              _createElementVNode("div", {
                class: "action_rate message-delivery-time-block",
                style: _normalizeStyle({ 'grid-template-columns': 'repeat(' + __props.deliverySetting.delivery_frequency + ', 1fr)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageContainer.value, (message, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (__props.deliverySetting.delivery_frequency >= message.step)
                      ? (_openBlock(), _createElementBlock("div", {
                          class: "block_rate border-none cursor-pointer",
                          key: index,
                          onClick: ($event: any) => (changeMessageSetting(message.step))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass([
                  'number_rate flex flex-column w-100',
                  { 'step-time-picked': props.isPickedTotalMessage || currentOrderMessage.value == message.step },
                ])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(message.date || message.defaultDate), 1),
                            _createElementVNode("span", null, _toDisplayString(message.time || message.defaultTime), 1)
                          ], 2)
                        ], 8, _hoisted_85))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ], 4),
              _createElementVNode("div", {
                class: "action_rate",
                style: _normalizeStyle({ 'grid-template-columns': 'repeat(' + __props.deliverySetting.delivery_frequency + ', 1fr)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageContainer.value, (message, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (__props.deliverySetting.delivery_frequency >= message.step)
                      ? (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (changeMessageSetting(message.step)),
                          key: index,
                          class: _normalizeClass([
                'block_rate border-grey cursor-pointer',
                { 'border-orange step-time-picked': props.isPickedTotalMessage || currentOrderMessage.value == message.step },
              ])
                        }, [
                          _createElementVNode("div", _hoisted_87, [
                            (!message.title)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(message.defaultDescription), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(message.title || message.messageDescription), 1)
                          ])
                        ], 10, _hoisted_86))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ], 4)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.finalSetting == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
            _createVNode(_component_Button, {
              label: "プレビュー確認",
              class: "ml-2 btn-outline btn-outline-orange",
              onClick: previewMessage
            })
          ]))
        : _createCommentVNode("", true),
      (__props.finalSetting == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
            _createVNode(_component_Button, {
              class: "col-2 black-btn ml-5",
              label: "前設定へ戻る",
              onClick: handleBackButton
            }),
            _createVNode(_component_Button, {
              class: "col-2 temp-save-btn ml-5",
              label: "下書き保存",
              onClick: saveDraft
            }),
            _createVNode(_component_Button, {
              class: "col-2 create-btn ml-5",
              label: "設定最終確認",
              onClick: save
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Dialog, {
      visible: warningReturnVisible.value,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((warningReturnVisible).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_91
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_92, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn ml-5",
            label: "下書き保存",
            onClick: saveDraft
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "戻る",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (warningReturnVisible.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn ml-5",
            label: "破棄する",
            onClick: disCardChanged
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: saveDraftVisible.value,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((saveDraftVisible).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_93
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_94, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "TOPに戻る",
            onClick: returnTop
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-5",
            label: "作成を続ける",
            onClick: returnCurrentPage
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: warningRedirectPage.value,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((warningRedirectPage).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_95
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_96, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn mr-5",
            label: "下書き保存",
            onClick: saveDraft
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn mr-5",
            label: "戻る",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (warningRedirectPage.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn",
            label: "破棄する",
            onClick: destroyWhenRedirect
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: upLoadImagePopUp.value,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((upLoadImagePopUp).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_97
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "upload-image-dialog",
          onClick: triggerFileInput
        }, _hoisted_101)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})